import { TextComponent } from 'baseComponents/TextComponent';
import { AdminPageWrapper } from 'components/layouts/AdminPageWrapper';
import { Flex, notification, Spin } from 'antd';
import { FullScreenLoaderComponent } from 'baseComponents/FullScreenLoaderComponent';
import './styles.scss';
import { AdminErrorPage } from 'components/AdminErrorPage';
import { AdminGlobalConfigurationForm } from 'components/AdminGlobalConfigurationForm';
import { useGetGlobalApiConfiguration } from 'hooks/useGetGlobalApiConfiguration';
import { useSetGlobalApiConfiguration } from 'hooks/useSetGlobalApiConfiguration';
import { queryClient } from 'constants/query-client';

export const AdminGlobalConfiguration = () => {
  const [api, contextHolder] = notification.useNotification();
  const {
    data: globalApiConfiguration = null,
    isLoading: isGlobalApiConfigurationLoading,
    isError: isGlobalApiConfigurationError,
    isRefetching,
    refetch,
  } = useGetGlobalApiConfiguration();

  const {
    mutate: setGlobalApiConfiguration,
    isPending: isSetGlobalApiConfigurationPending,
  } = useSetGlobalApiConfiguration({
    onSuccess: () => {
      api.success({
        message: `Global API configuration updated`,
        description: 'Global API configuration has been successfully updated',
        duration: 3,
      });
      queryClient.invalidateQueries({
        queryKey: ['getGlobalApiConfiguration'],
      });
    },
    onError: (e) => {
      api.error({
        message: 'Something went wrong',
        description:
          e.message ||
          'Something went wrong with updating global API configuration. Please try again later.',
        duration: 3,
      });
    },
  });

  if (isGlobalApiConfigurationError) {
    return (
      <AdminErrorPage
        isRefetching={isRefetching}
        refetch={refetch}
        error={'Error fetching API configuration'}
      />
    );
  }

  return (
    <AdminPageWrapper sidebar={<div style={{ width: 160 }} />}>
      {contextHolder}
      <TextComponent size='table-title-size' text='Global Configuration' />

      {isGlobalApiConfigurationLoading ? (
        <Flex justify='center' align='center' style={{ height: 200 }}>
          <Spin size='large' />
        </Flex>
      ) : (
        <AdminGlobalConfigurationForm
          data={globalApiConfiguration}
          onSave={(rows) => {
            setGlobalApiConfiguration(rows);
          }}
          isLoading={
            isGlobalApiConfigurationLoading ||
            isSetGlobalApiConfigurationPending
          }
        />
      )}
      <FullScreenLoaderComponent
        spinning={
          isGlobalApiConfigurationLoading || isSetGlobalApiConfigurationPending
        }
      />
    </AdminPageWrapper>
  );
};
